export const AUTOMATED_BUFFER_TITLE =
  'To opt out all lines, switch the toggle in the header to Off (red). To opt out specific lines, switch the toggle in the corresponding row to Off (red). You can manually set a buffer value for individual lines.';

export const USER_APPLIED_BUFFER_TITLE =
  'To opt in all lines, switch the toggle in the header to On (green). To opt in specific lines, switch the toggle in the corresponding row to On (green). Click the pencil icon to edit the buffer value on opted out lines (optional).';

export const AUTOMATED_TOOLTIP =
  'The buffer value displayed is automatically generated based on machine learning for optimal delivery performance for the line item. This is the default setting and recommended.';

export const USER_APPLIED_TOOLTIP =
  'This line is opted out of automated buffers. Click the Edit icon to set a buffer value for the line item (optional).';

export const INTERNATIONAL_LINE_TOOLTIP = 'Automated buffers cannot be applied to international lines';
